<template>
  <b-alert show variant="info">
    <b-spinner small class="mr-2"></b-spinner>
    {{ message || 'One moment, loading data.' }}
  </b-alert>
</template>
<script>
  export default {
    props: {
      message: String
    }
  }
</script>
